import React, { useEffect, useState } from 'react'
import { TabPanel } from 'primereact/tabview'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { CustomPanel, CustomTabView, Loading, PageHeader } from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import { errorHandler } from '../../../../../services/util/error.service'
import {
  getReconferenciaEtiquetaResumo,
  postReconferenciaEtiquetaResumoFinalizar,
  postReconferenciaEtiquetaResumoOcorrencias,
} from '../../../../../services/api/https/picking/picking.http'
import { urlGetImprimirReconferenciaEtiquetaResumo } from '../../../../../services/api/routes/picking.routes'
import ApuracaoOcorrencias from './ApuracaoOcorrencias'
import EmitirResumoEtiqueta, { buildForm } from './EmitirResumoEtiqueta'

function getOcorrencias(resumo, type) {
  return resumo.missing_reasons.filter(r => r.type === type).map(r => ({ id: r.id, name: r.name }))
}

function getSelecionadas(itens) {
  return itens.reduce((acc, item) => ({ ...acc, [item.id]: item.missing_reason }), {})
}

function ResumoSeparacaoEtiqueta({ dispatch, history, selectedTp }) {
  const [isLoading, setIsLoading] = useState(true)
  const [resumo, setResumo] = useState(null)
  const [selecionadas, setSelecionadas] = useState({ faltas: {}, sobras: {} })
  const [form, setForm] = useState(null)

  const conferenciaId = history.location.state && history.location.state.conferencia_id

  useEffect(() => {
    if (conferenciaId) carregarResumo()
  }, [conferenciaId])

  const aplicarResumo = dados => {
    setResumo(dados)
    setSelecionadas({
      faltas: getSelecionadas(dados.faltas),
      sobras: getSelecionadas(dados.sobras),
    })
    setForm(buildForm(dados.info))
  }

  const carregarResumo = async () => {
    setIsLoading(true)
    try {
      aplicarResumo(await getReconferenciaEtiquetaResumo(conferenciaId, selectedTp))
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setIsLoading(false)
    }
  }

  const executar = async (loadingMessage, acao, successMessage) => {
    dispatch(showLoadingBox(loadingMessage, 'Aguarde . . .'))
    try {
      await acao()
      dispatch(hideLoadingBox())
      dispatch(showMessageBox(successMessage, null))
    } catch (e) {
      dispatch(hideLoadingBox())
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const onOcorrenciaChange = (tipo, id, ocorrencia) => {
    setSelecionadas(prev => ({ ...prev, [tipo]: { ...prev[tipo], [id]: ocorrencia } }))
  }

  const associarOcorrencias = tipo => {
    const associacoes = resumo[tipo]
      .filter(item => selecionadas[tipo][item.id])
      .map(item => ({ id: item.id, missing_reason_id: selecionadas[tipo][item.id].id }))
    if (!associacoes.length) {
      dispatch(showMessageBox(null, 'Selecione a Ocorrência de ao menos um produto'))
      return
    }
    executar(
      'Associando ocorrências',
      async () => {
        await postReconferenciaEtiquetaResumoOcorrencias(
          conferenciaId,
          tipo,
          associacoes,
          selectedTp,
        )
        const atualizado = await getReconferenciaEtiquetaResumo(conferenciaId, selectedTp)
        setResumo(prev => ({ ...prev, [tipo]: atualizado[tipo] }))
        setSelecionadas(prev => ({ ...prev, [tipo]: getSelecionadas(atualizado[tipo]) }))
      },
      'Ocorrências associadas com sucesso',
    )
  }

  const finalizarResumo = dados => {
    executar(
      'Finalizando Resumo . . .',
      async () => {
        await postReconferenciaEtiquetaResumoFinalizar(conferenciaId, dados, selectedTp)
        aplicarResumo(await getReconferenciaEtiquetaResumo(conferenciaId, selectedTp))
      },
      'Resumo Finalizado com Sucesso',
    )
  }

  const imprimirResumo = () => {
    window.open(urlGetImprimirReconferenciaEtiquetaResumo(conferenciaId, selectedTp), '_blank')
  }

  if (!conferenciaId) {
    history.goBack()
    return null
  }

  const isDisabled = !resumo || resumo.info.status !== 'Finalizado'

  return (
    <div>
      <PageHeader>
        <span>4.9 - Resumo de Separação:</span>
        <strong>
          {resumo
            ? `Conferência ${resumo.info.id} - Pallet ${resumo.info.pallet_area_id} - ${resumo.info.empresa_nome}`
            : ''}
        </strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          {isLoading ? (
            <div className="text-center">
              <Loading />
            </div>
          ) : resumo ? (
            <CustomTabView activeIndex={0}>
              <TabPanel header="Apuração das Faltas">
                <ApuracaoOcorrencias
                  titulo="Listagem das Faltas Apuradas"
                  mensagemVazia="Não existem Faltas"
                  itens={resumo.faltas}
                  selecionadas={selecionadas.faltas}
                  ocorrencias={getOcorrencias(resumo, 'Falta')}
                  disabled={isDisabled}
                  onChange={(id, ocorrencia) => onOcorrenciaChange('faltas', id, ocorrencia)}
                  onAssociar={() => associarOcorrencias('faltas')}
                />
              </TabPanel>
              <TabPanel header="Sobras">
                <ApuracaoOcorrencias
                  titulo="Listagem das Sobras Apuradas"
                  mensagemVazia="Não existem Sobras"
                  itens={resumo.sobras}
                  selecionadas={selecionadas.sobras}
                  ocorrencias={getOcorrencias(resumo, 'Sobra')}
                  disabled={isDisabled}
                  onChange={(id, ocorrencia) => onOcorrenciaChange('sobras', id, ocorrencia)}
                  onAssociar={() => associarOcorrencias('sobras')}
                />
              </TabPanel>
              <TabPanel header="Resumo de Separação">
                <EmitirResumoEtiqueta
                  status={resumo.info.status}
                  form={form}
                  faltas={resumo.faltas}
                  sobras={resumo.sobras}
                  onChange={(name, value) => setForm(prev => ({ ...prev, [name]: value }))}
                  onFinalizar={finalizarResumo}
                  onImprimir={imprimirResumo}
                  onErro={erro => dispatch(showMessageBox(null, erro))}
                />
              </TabPanel>
            </CustomTabView>
          ) : (
            <p>Conferência não encontrada</p>
          )}
        </CustomPanel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(ResumoSeparacaoEtiqueta))
